import React, { useState, useEffect } from 'react';

const API_URL = 'https://nethajiprime-backend.onrender.com';
const C = { bg:'#040000',bg2:'#0e0101',gold:'#f5c842',gold2:'#d4a843',gold3:'#b8922e',red:'#cc0000',cream:'#f0e6cc',cream2:'#c8b89a',muted:'#8a7060',border:'rgba(212,168,67,0.15)' };

function Leaderboard({ onBack, onVideoSelect }) {
  const [topViewed,setTopViewed]=useState([]);
  const [topLiked,setTopLiked]=useState([]);
  const [topHyped,setTopHyped]=useState([]);
  const [topSpeakers,setTopSpeakers]=useState([]);
  const [activeTab,setActiveTab]=useState('views');
  const [loading,setLoading]=useState(true);

  useEffect(()=>{ fetchLeaderboard(); },[]);

  const [viralData, setViralData] = React.useState(null);
  const [userPoints, setUserPoints] = React.useState(null);

  const fetchLeaderboard = async () => {
    try {
      // Fetch viral dashboard
      try {
        const vd = await fetch(`${API_URL}/api/viral-dashboard`).then(r=>r.json());
        setViralData(vd);
      } catch(e) {}
      const res = await fetch(`${API_URL}/speeches`);
      const data = await res.json();
      const videos = data.speeches || [];
      setTopViewed([...videos].sort((a,b)=>(b.views_count||0)-(a.views_count||0)).slice(0,10));
      setTopLiked([...videos].sort((a,b)=>(b.like_count||0)-(a.like_count||0)).slice(0,10));
      setTopHyped([...videos].sort((a,b)=>(b.hype_count||0)-(a.hype_count||0)).slice(0,10));
      const sm = {};
      videos.forEach(v => {
        if(!sm[v.speaker_name]) sm[v.speaker_name]={name:v.speaker_name,totalViews:0,totalLikes:0,totalHypes:0,videoCount:0};
        sm[v.speaker_name].totalViews+=v.views_count||0;
        sm[v.speaker_name].totalLikes+=v.like_count||0;
        sm[v.speaker_name].totalHypes+=v.hype_count||0;
        sm[v.speaker_name].videoCount++;
      });
      setTopSpeakers(Object.values(sm).sort((a,b)=>b.totalViews-a.totalViews));
      setLoading(false);
    } catch(e){ setLoading(false); }
  };

  const rankColors = ['#FFD700','#C0C0C0','#CD7F32'];
  const rankEmoji = i => i===0?'🥇':i===1?'🥈':i===2?'🥉':`#${i+1}`;
  const getList = () => activeTab==='views'?topViewed:activeTab==='likes'?topLiked:activeTab==='hypes'?topHyped:topSpeakers;
  const getStat = (item,tab) => tab==='views'?item.views_count||0:tab==='likes'?item.like_count||0:tab==='hypes'?item.hype_count||0:item.totalViews;
  const statColors = { views:C.gold2, likes:'#ff6b6b', hypes:'#ff8c42' };

  const tabs = [
    {id:'views',label:'👁 Most Viewed'},
    {id:'likes',label:'👍 Most Liked'},
    {id:'hypes',label:'🔥 Most Hyped'},
    {id:'speakers',label:'🎤 Top Speakers'},
  ];

  return (
    <div style={{background:C.bg,minHeight:'100vh',color:C.cream,fontFamily:"'Barlow',sans-serif"}}>
      {/* Header */}
      <header style={{position:'sticky',top:0,zIndex:100,background:'rgba(4,0,0,0.97)',backdropFilter:'blur(20px)',borderBottom:`1px solid ${C.border}`,padding:'0 4%',height:'66px',display:'flex',alignItems:'center',gap:'16px'}}>
        <button onClick={onBack} style={{background:'none',border:`1px solid ${C.border}`,color:C.gold2,padding:'7px 18px',borderRadius:'20px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'13px',fontWeight:'700',letterSpacing:'1px'}}>← Back</button>
        <span style={{fontFamily:"'Cinzel',serif",fontSize:'1.2em',fontWeight:'900',color:C.gold,letterSpacing:'3px',textShadow:`0 0 20px rgba(245,200,66,0.4)`}}>NETHAJI PRIME</span>
      </header>

      {/* Hero */}
      <div style={{position:'relative',padding:'60px 4%',background:`linear-gradient(135deg, #0e0101, #1a0303)`,borderBottom:`1px solid ${C.border}`,textAlign:'center',overflow:'hidden'}}>
        <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse 60% 80% at 50% 0%, rgba(180,0,0,0.2), transparent)',pointerEvents:'none'}} />
        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'11px',fontWeight:'800',letterSpacing:'4px',color:C.gold2,marginBottom:'12px',display:'flex',alignItems:'center',justifyContent:'center',gap:'10px'}}>
          <span style={{width:'6px',height:'6px',borderRadius:'50%',background:C.red,boxShadow:`0 0 8px ${C.red}`,display:'inline-block'}} />
          HALL OF FAME
        </div>
        <h1 style={{fontFamily:"'Cinzel',serif",fontSize:'clamp(2em,5vw,3.5em)',fontWeight:'900',color:C.gold,letterSpacing:'3px',marginBottom:'12px',textShadow:`0 0 40px rgba(245,200,66,0.3)`}}>🏆 Top Charts</h1>
        <p style={{color:C.cream2,fontSize:'15px'}}>Most popular Tamil political speeches on Nethaji Prime</p>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',borderBottom:`1px solid ${C.border}`,overflowX:'auto',background:'rgba(4,0,0,0.8)',backdropFilter:'blur(10px)',position:'sticky',top:'66px',zIndex:99}}>
        {tabs.map(tab=>(
          <button key={tab.id} onClick={()=>setActiveTab(tab.id)} style={{
            padding:'16px 28px',background:'transparent',
            color:activeTab===tab.id?C.gold:C.muted,
            border:'none',borderBottom:activeTab===tab.id?`3px solid ${C.gold}`:'3px solid transparent',
            cursor:'pointer',fontSize:'13px',fontWeight:'800',whiteSpace:'nowrap',
            fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1.5px',
            transition:'all 0.2s',textTransform:'uppercase',
          }}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{maxWidth:'900px',margin:'0 auto',padding:'40px 4%'}}>
        {loading ? (
          <div style={{textAlign:'center',padding:'80px',color:C.muted}}>
            <div style={{fontFamily:"'Cinzel',serif",color:C.gold2,marginBottom:'12px'}}>Loading leaderboard...</div>
          </div>
        ) : activeTab==='speakers' ? (
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'800',letterSpacing:'3px',color:C.gold3,marginBottom:'24px'}}>TOP SPEAKERS BY TOTAL VIEWS</div>
            {topSpeakers.map((spk,i)=>(
              <div key={spk.name} style={{display:'flex',alignItems:'center',gap:'16px',padding:'18px 20px',background:`linear-gradient(135deg, #1a0303, #0e0101)`,borderRadius:'10px',marginBottom:'10px',border:`1px solid ${i<3?rankColors[i]+'44':C.border}`,transition:'all 0.2s',cursor:'default'}}
                onMouseEnter={e=>{e.currentTarget.style.transform='translateX(6px)';e.currentTarget.style.borderColor=C.gold2+'66';}}
                onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.borderColor=i<3?rankColors[i]+'44':C.border;}}>
                <div style={{width:'48px',height:'48px',borderRadius:'50%',background:i<3?rankColors[i]:'rgba(212,168,67,0.1)',border:`2px solid ${i<3?rankColors[i]:C.border}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:i<3?'1.4em':'14px',fontWeight:'900',color:i<3?'#000':C.muted,flexShrink:0}}>
                  {rankEmoji(i)}
                </div>
                <div style={{flex:1}}>
                  <div style={{color:C.cream,fontWeight:'700',fontSize:'15px',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px',marginBottom:'4px'}}>🎤 {spk.name}</div>
                  <div style={{color:C.muted,fontSize:'12px'}}>{spk.videoCount} video{spk.videoCount!==1?'s':''}</div>
                </div>
                <div style={{display:'flex',gap:'24px',textAlign:'center'}}>
                  {[{v:spk.totalViews,l:'Views',c:C.gold2},{v:spk.totalLikes,l:'Likes',c:'#ff6b6b'},{v:spk.totalHypes,l:'Hypes',c:'#ff8c42'}].map(({v,l,c})=>(
                    <div key={l}><div style={{color:c,fontWeight:'800',fontSize:'16px',fontFamily:"'Barlow Condensed',sans-serif"}}>{v}</div><div style={{color:C.muted,fontSize:'11px',letterSpacing:'1px'}}>{l}</div></div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'800',letterSpacing:'3px',color:C.gold3,marginBottom:'24px'}}>
              {activeTab==='views'?'TOP VIDEOS BY VIEWS':activeTab==='likes'?'TOP VIDEOS BY LIKES':'TOP VIDEOS BY HYPES'}
            </div>
            {getList().map((video,i)=>(
              <div key={video.id} onClick={()=>onVideoSelect&&onVideoSelect(video)}
                style={{display:'flex',alignItems:'center',gap:'16px',padding:'14px 18px',background:`linear-gradient(135deg, #1a0303, #0e0101)`,borderRadius:'10px',marginBottom:'10px',border:`1px solid ${i<3?rankColors[i]+'44':C.border}`,cursor:'pointer',transition:'all 0.2s'}}
                onMouseEnter={e=>{e.currentTarget.style.transform='translateX(6px)';e.currentTarget.style.borderColor=C.gold2;}}
                onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.borderColor=i<3?rankColors[i]+'44':C.border;}}>
                <div style={{width:'48px',height:'48px',borderRadius:'50%',background:i<3?rankColors[i]:'rgba(212,168,67,0.1)',border:`2px solid ${i<3?rankColors[i]:C.border}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:i<3?'1.4em':'13px',fontWeight:'900',color:i<3?'#000':C.muted,flexShrink:0}}>
                  {rankEmoji(i)}
                </div>
                {video.thumbnail_url
                  ? <img src={video.thumbnail_url} alt={video.title} style={{width:'80px',height:'50px',objectFit:'cover',borderRadius:'6px',flexShrink:0,border:`1px solid ${C.border}`}} />
                  : <div style={{width:'80px',height:'50px',background:'rgba(212,168,67,0.06)',borderRadius:'6px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,fontSize:'1.5em',border:`1px solid ${C.border}`}}>🎬</div>
                }
                <div style={{flex:1,overflow:'hidden'}}>
                  <div style={{color:C.cream,fontWeight:'600',fontSize:'14px',marginBottom:'4px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{video.title}</div>
                  <div style={{color:C.muted,fontSize:'12px'}}>🎤 {video.speaker_name} · {video.category}</div>
                </div>
                <div style={{textAlign:'right',flexShrink:0}}>
                  <div style={{color:statColors[activeTab]||C.gold2,fontWeight:'900',fontSize:'20px',fontFamily:"'Barlow Condensed',sans-serif"}}>{getStat(video,activeTab)}</div>
                  <div style={{color:C.muted,fontSize:'11px',letterSpacing:'1px'}}>{activeTab}</div>
                </div>
              </div>
            ))}
            {getList().length===0&&<div style={{textAlign:'center',padding:'60px',color:C.muted}}>No videos yet. Start watching and engaging!</div>}
          </div>
        )}
      </div>
    </div>
  );
}
export default Leaderboard;